// import { createSlice } from "@reduxjs/toolkit";

// const authSlice = createSlice({
//   name: "auth",
//   initialState: {
//     isAuthenticated: false, 
//     user: null, 
//   },
//   reducers: {
//     login: (state, action) => {
//       state.isAuthenticated = true;
//       state.user = action.payload;
//     },
//     logout: (state) => {
//       state.isAuthenticated = false;
//       state.user = null;
//     },
//   },
// });

// export const { login, logout } = authSlice.actions;
// export default authSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: localStorage.getItem("adminToken") || null, // Load token from localStorage
  },
  reducers: {
    login: (state, action) => {
      const { user, token } = action.payload;

      // Store token in localStorage
      localStorage.setItem("adminToken", token);

      state.user = action.payload;
      state.token = token;
    },
    logout: (state) => {
      // Remove token from localStorage
      localStorage.removeItem("adminToken");

      state.user = null;
      state.token = null;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;

